import { render, staticRenderFns } from "./ClientSelectTable.vue?vue&type=template&id=03052a8f"
import script from "./ClientSelectTable.vue?vue&type=script&lang=ts"
export * from "./ClientSelectTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports